import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IVerifyUser } from '../../../entity/interface/iAuthApis';
import { IAuthRepository } from '../../repositories/interfaces/iAuthRepository';

export interface IVerifyUserUseCase {
    execute(username: string, recaptchaToken: string | null, apiToken: { [key: string]: string }): Promise<IVerifyUser>;
}

export class VerifyUserUseCase implements IVerifyUserUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get authRepo(): IAuthRepository {
        return container.resolve<IAuthRepository>(DI.REPOSITORIES.IAuthRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        username: string,
        recaptchaToken: string | null,
        apiToken: { [key: string]: string }
    ): Promise<IVerifyUser> {
        const response = await this.authRepo.verifyUser(username, recaptchaToken, apiToken);
        return response.data as IVerifyUser;
    }
}
